import { render, staticRenderFns } from "./sleeveManage.vue?vue&type=template&id=42cddd7a&scoped=true"
import script from "./sleeveManage.vue?vue&type=script&lang=js"
export * from "./sleeveManage.vue?vue&type=script&lang=js"
import style0 from "./sleeveManage.vue?vue&type=style&index=0&id=42cddd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cddd7a",
  null
  
)

export default component.exports